<template>
  <!-- Content Header (Page header) -->
  <div v-if="halamanloading" style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;">
    <h1>
      <br><img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;"><br><br>.. LOADING ..
    </h1>
  </div>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
        </div>
        <!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/DashboardBalai">Dashboard Direktorat / Balai</a></li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="cardputih">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <div class="info-box mb-3">
                    <span class="info-box-icon bg-primary elevation-1 animation__shake"><i
                        class="fas fa-calendar"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text" style="font-size: large;">Tanggal Data</span>
                      <span class="info-box-number" style="font-size: small;"> {{ G_formatDate(datadashboard.tanggalEmon)
                      }}</span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!-- /.info-box -->
                </div>
                <!-- /.col-md-3 -->
                <div class="col-lg-5">
                  <label style="font-size: large;">Pilihan Balai</label>
                  <v-select :options="balai" :reduce="(label) => label.code" label="label" v-model="defaultSelectedBalai"
                    @update:modelValue="onBalaiChange" id="pilihanbalai"></v-select>
                </div>
                <div class="col-lg-3">
                  <label style="font-size: large;">Pilihan Tahun</label>
                  <v-select :options="tahun" :reduce="(label) => label.code" label="label" v-model="defaultSelectedTahun"
                    @update:modelValue="onTahunChange" id="pilihantahun"></v-select>
                </div>
              </div>
              <!-- /.row -->
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.cardputih -->
        </div>
        <!-- /.col-md-12 text-center -->
      </div>
      <div class="row">&nbsp;</div>
      <div class="row">
        <div class="col-md-4 text-center">
          <div class="cardputih">
            <div class="card-header">
              <h3 class="card-title">Rekapitulasi {{ selected }} Tahun {{ G_AmbilTahun(datadashboard.tanggalEmon) }} </h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <div>&nbsp;</div>
                  <div class="info-box bg-info mb-3">
                    <span class="info-box-icon bg-info elevation-1 animation__shake"><i
                        class="fa fa-info-circle"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text" style="font-size: xx-large;">{{ G_numKoma(datadashboard.prsDipa) }} <i
                          class="fa fa-percent"></i></span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!-- /.info-box -->
                  <div>&nbsp;</div>
                  <div class="card-body table-responsive p-0">
                    <table class="table table-striped table-valign-middle">
                      <tbody>
                        <tr>
                          <td><span style="font-size: medium;" class="text-success">Pagu DIPA</span></td>
                          <td><span style="font-size: medium;" class="text-success">{{ G_numFormat(datadashboard.paguDipa)
                          }}</span></td>
                        </tr>
                        <tr>
                          <td><span style="font-size: medium;" class="text-primary">Realisasi DIPA</span></td>
                          <td><span style="font-size: medium;" class="text-primary">{{
                            G_numFormat(datadashboard.realisasiDipa) }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>&nbsp;</div>
                  <div>&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <div class="cardputih">
            <div class="card-header">
              <h3 class="card-title">Progres Penyerapan DIPA Tahun {{ G_AmbilTahun(tahunpenyerapandipa) }}</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <PieChartPenyerapan style="width: 100%;" type="donut" :options="chartOptionsPenyerapan"
                    :series="seriesPenyerapan"></PieChartPenyerapan>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <div class="cardputih">
            <div class="card-header">
              <h3 class="card-title">Infografis Jumlah Status Paket Tahun {{ G_AmbilTahun(tahunstatuspaket) }}</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <apexcharts style="width: 100%;" type="donut" :options="chartOptions" :series="series"></apexcharts>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="row">&nbsp;</div>
      <div class="row">&nbsp;</div>
      <div class="row">&nbsp;</div>
      <!-- /.col-md-12 text-center -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content -->
</template>
  
<script>
import axios from "axios";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
//import { Doughnut } from "vue-chartjs";
//import Chart from 'chart.js'
//import PieChart from '../../components/Chart/DashboardBalai/DonutBalaiStatusPaket.vue';
//import PieChartPenyerapan from '../../components/Chart/DashboardBalai/DonutBalaiPenyerapanDIPA.vue';

export default {
  components: {
    PieChartPenyerapan: VueApexCharts, apexcharts: VueApexCharts, vSelect,
  },
  data() {
    return {
      tahunfilter:new Date().getFullYear(),
      filter:'0',
      defaultSelectedBalai: {
        code: "0",
        label: "Semua Balai"
      },
      selectedtahun: new Date().getFullYear(),
      defaultSelectedTahun: {
        code: 0,
        label: new Date().getFullYear()
      },
      balai: [],
      tahun: [],
      halamanloading: true,
      selected: "",
      kdbalai: "",
      datatotal: [],
      datamasterbalai: [],
      datadashboard: [],
      datagrafikpiestatuspaket: [],
      datagrafikpiestatusPenyerapan: [],
      datatahun: [],
      tahunjalan: new Date().getFullYear(),
      tahunpenyerapandipa: "",
      tahunstatuspaket: "",
      key: "",
      keytahun: "",
      chartOptions: {
        chart: {
          id: 'vuechart-statuspaket_abc',
        },
        title: {
          text: "",
          align: "center",
          margin: 10,
          style: {
            fontSize: "9px",
            fontWeight: "bold",
            color: "#2E93fA",
          },
        },
        colors: ['#FF0000', '#FA8072', '#191970', '#FFA500', '#20B2AA', '#32CD32'],
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          position: 'bottom',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  },
                },
                value: {
                  formatter: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  },
                },
                total: {
                  formatter: function (w) {
                    let setTotal = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    let val = (setTotal / 1).toFixed(0).replace('.', ',')
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  },
                  show: true,
                },
              }
            }
          }
        },
        labels: [],
      },
      chartOptionsPenyerapan: {
        chart: {
          id: 'vuechart-penyerapandipa',
        },
        title: {
          text: "",
          align: "center",
          margin: 10,
          style: {
            fontSize: "9px",
            fontWeight: "bold",
            color: "#2E93fA",
          },
        },
        colors: ['#32CD32', '#FF4500'],
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          position: 'bottom',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  formatter: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  },
                },
                value: {
                  formatter: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  },
                },
                total: {
                  formatter: function (w) {
                    let setTotal = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    let val = (setTotal / 1).toFixed(0).replace('.', ',')
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  },
                  show: true,
                },
              }
            }
          }
        },
        labels: []
      },
      series: [],
      seriesPenyerapan: [],
    }
  },
  methods: {
    onBalaiChange(a) {
      //console.log(this.balai[a].code);
      //console.log(this.tahun[a].code);
      this.selected = this.balai[a].label;
      this.kdbalai = this.balai[a].code;
      this.filter = this.kdbalai;
      this.tahunfilter = this.selectedtahun;
      this.updateData();
        
    },
    onTahunChange(a) {
      //console.log(this.tahun[a].label);
      this.filter = this.kdbalai;
      this.selectedtahun = this.tahun[a].label;
      this.tahunfilter = this.selectedtahun;
      JSON.parse(localStorage.getItem("userLogin"));
      //console.log(filter);
      //console.log(tahunfilter);
      if (this.filter == '0') { this.filter = '' }
      if (this.tahunfilter == '0') { this.tahunfilter = new Date().getFullYear() }
      this.updateData();
    },

    updateData(){
      JSON.parse(localStorage.getItem("userLogin"));
      //console.log(filter);
      //console.log(tahunfilter);
      if (this.filter == '0') { this.filter = '' }
      if (this.tahunfilter == '0') { this.tahunfilter = new Date().getFullYear() }
      const mainAPIDsahboard = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      mainAPIDsahboard.get("dashboard/summary?tahun=" + this.tahunfilter + "&kdbalai=" + this.filter)
        .then(
          Response => {
            //console.log(Response.data);
            this.datadashboard = Response.data;
            //this.selected = this.defaultSelectedBalai.label;
          }
        ).catch(error => {
          console.log(error);
          this.datadashboard=[];
          this.halamanloading = false;
          window.location.replace("/");
        });
      const mainAPIDataGrafikStatus = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      mainAPIDataGrafikStatus.get("kontraktual/summary/byStatus/count/pie?tahun=" + this.tahunfilter + "&kdbalai=" + this.filter)
        .then(
          Response => {
            this.datagrafikpiestatuspaket = Response.data;
            this.tahunstatuspaket = this.datagrafikpiestatuspaket.tanggalEmon;
            //console.log(this.datagrafikpiestatuspaket.total);
            this.series = this.datagrafikpiestatuspaket.data;
            this.chartOptions = {
              labels: this.datagrafikpiestatuspaket.label,
              title: {
                text: this.selected,
              }
            }
          }
        ).catch(error => {
          console.log(error);
          this.datagrafikpiestatuspaket=[]
          this.series = [];
          this.halamanloading = false;
          //window.location.replace("/");
        });

      const mainAPIDataGrafikPenyerapan = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      mainAPIDataGrafikPenyerapan.get("dashboard/penyerapan-dipa/pie?tahun=" + this.tahunfilter + "&kdbalai=" + this.filter)
        .then(
          Response => {
            this.datagrafikpiestatusPenyerapan = Response.data;
            this.tahunpenyerapandipa = this.datagrafikpiestatusPenyerapan.tanggalEmon;
            //console.log(this.datagrafikpiestatusPenyerapan.total);
            this.seriesPenyerapan = this.datagrafikpiestatusPenyerapan.data;
            this.chartOptionsPenyerapan = {
              labels: this.datagrafikpiestatusPenyerapan.label,
              title: {
                text: this.selected,
              }
            }
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.datagrafikpiestatusPenyerapan = [];
          this.seriesPenyerapan = [];
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    async AmbilDataBalai() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/balai")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterbalai = Response.data.content;
            //console.log(this.datamasterbalai.content);
            this.datamasterbalai.forEach((item) => {
              this.balai.push({
                label: item.nmbalai,
                code: item.kdbalai,
              });
            });
            this.balai.unshift({
              label: 'Semua Balai',
              code: '0',
            });
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        })
    },
    async AmbilDataTahun() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPITahun = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPITahun.get("progres/tahun")
        .then(
          Response => {
            this.datatahun = Response.data.content;
            //console.log(this.datatahun);
            //this.selected = document.getElementById('pilihantahun').options[0].text;
            this.datatahun.forEach((item) => {
              this.tahun.push({
                label: item,
                code: this.datatahun.indexOf(item),
              });
            });
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    async AmbilDataDashboard() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      let filter = this.defaultSelectedBalai.code;
      let tahunfilter = this.defaultSelectedTahun.code;
      //console.log(this.defaultSelectedBalai.code);
      if (filter != '0') { filter = this.defaultSelectedBalai.code }
      else { filter = '' }
      if (tahunfilter != '') { tahunfilter = this.defaultSelectedTahun.code }
      else { tahunfilter = '' }
      //console.log(document.getElementById('pilihanbalai').value);
      const mainAPIDsahboard = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIDsahboard.get("dashboard/summary?tahun=" + tahunfilter + "&kdbalai=" + filter)
        .then(
          Response => {
            //console.log(Response.data);
            this.datadashboard = Response.data;
            this.selected = this.defaultSelectedBalai.label;
          }
        ).catch(error => {
          console.log(error);
          window.location.replace("/");
        });
      const mainAPIDataGrafikStatus = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIDataGrafikStatus.get("kontraktual/summary/byStatus/count/pie?tahun=" + tahunfilter + "&kdbalai=" + filter)
        .then(
          Response => {
            this.datagrafikpiestatuspaket = Response.data;
            this.tahunstatuspaket = this.datagrafikpiestatuspaket.tanggalEmon;
            //console.log(this.datagrafikpiestatuspaket.total);
            this.series = this.datagrafikpiestatuspaket.data;
            this.chartOptions = {
              labels: this.datagrafikpiestatuspaket.label,
              title: {
                text: this.defaultSelectedBalai.label,
              }
            };
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });

      const mainAPIDataGrafikPenyerapan = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIDataGrafikPenyerapan.get("dashboard/penyerapan-dipa/pie?tahun=" + tahunfilter + "&kdbalai=" + filter)
        .then(
          Response => {
            this.datagrafikpiestatusPenyerapan = Response.data;
            this.tahunpenyerapandipa = this.datagrafikpiestatusPenyerapan.tanggalEmon;
            //console.log(this.datagrafikpiestatusPenyerapan.total);
            this.seriesPenyerapan = this.datagrafikpiestatusPenyerapan.data;
            this.chartOptionsPenyerapan = {
              labels: this.datagrafikpiestatusPenyerapan.label,
              title: {
                text: this.defaultSelectedBalai.label,
              }
            }
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
  },
  created() {
    this.halamanloading = true;
  },
  beforeMount() {
    this.halamanloading = true;
  },
  mounted() {
    //this.getTotal();
    this.AmbilDataTahun();
    this.AmbilDataBalai();
    this.AmbilDataDashboard();
    document.getElementById('DashboardGrup').className = 'nav-item menu-open';
    document.getElementById('MonitoringGrup').className = 'nav-item menu-close';
    document.getElementById('PaketKontraktualGrup').className = 'nav-item menu-close';
    document.getElementById('PrognosisGrup').className = 'nav-item menu-close';
    document.getElementById('KendalaGrup').className = 'nav-item menu-close';
    document.getElementById('AWPGrup').className = 'nav-item menu-close';
    document.getElementById('PengecekanGrup').className = 'nav-item menu-close';
    document.getElementById('FormIsianGrup').className = 'nav-item menu-close';
    document.getElementById('KompilasiGrup').className = 'nav-item menu-close';
    document.getElementById('bodyLMS').className = 'hold-transition sidebar-mini layout-fixed';
    const sidebar = document.querySelector('aside');
    sidebar.style.display = 'block';
    const nav = document.querySelector('nav');
    nav.style.visibility = 'visible';
    //document.getElementById('Atas').style.visibility = 'visible';
    const footer = document.querySelector('footer');
    footer.style.visibility = 'visible';
  },
};
</script>
  
<style></style>